import React from "react";
import {
  Box,
  InputLabel,
  Paper,
  Rating,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const RatingPrecision = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Rating Precision
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          The rating can display any float number with the value prop. Use the
          precision prop to define the minimum increment value change allowed.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor language={"js"} value={`
            <InputLabel shrink>Half Rating</InputLabel>
            <Rating name="half-rating" defaultValue={2.5} precision={0.5} />

            <InputLabel shrink>Read only</InputLabel>
            <Rating
              name="half-rating-read"
              defaultValue={2.5}
              precision={0.5}
              readOnly
            />
          `}>
            <Box
              sx={{
                "& > .MuiInputLabel-root": { mt: 2 },
              }}
            >
              <InputLabel shrink>Half Rating</InputLabel>
              <Rating name="half-rating" defaultValue={2.5} precision={0.5} />

              <InputLabel shrink>Read only</InputLabel>
              <Rating
                name="half-rating-read"
                defaultValue={2.5}
                precision={0.5}
                readOnly
              />
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default RatingPrecision;
